// import engine from 'store/src/store-engine'
// import localStorage from 'store/storages/localStorage'
// import sessionStorage from 'store/storages/sessionStorage'
import store from 'store'
import expirePlugin from 'store/plugins/expire'
import updatePlugin from 'store/plugins/update'

// import engine from 'store/src/store-engine'
// import storages from 'store/storages/all'
// import plugins from 'store/plugins/all'

// const store = engine.createStore([localStorage])
store.addPlugin(expirePlugin)
store.addPlugin(updatePlugin)

// const session = engine.createStore([sessionStorage])

const session = {
  get: (key) => sessionStorage.getItem(key),
  set: (key, value) => sessionStorage.setItem(key, value),
  remove: (key) => sessionStorage.removeItem(key)
}

// export default engine.createStore(storages, plugins, 'lmm')
export default store
export {session, store}
